import client from '@/config/directus.api';
import { isInteger, isObject } from 'lodash';

const COLLECTION = 'bb_sm_config';

class SocialMediaConfig {
  constructor(payload) {
    this.status = payload.status || 'published';
    this.name = payload.name;
    this.tags = payload.tags;
    this.auto_publication = payload.auto_publication;
    this.token = payload.token;
    this.page_id = payload.page_id;

    /**
     * UPDATE RELATIONS
     */
    // Platform
    if (payload.hasOwnProperty('platform') && isObject(payload.platform) && payload.platform.hasOwnProperty('id')) {
      this.platform = { id: payload.platform.id };
    } else if (isInteger(payload.platform)) {
      this.platform = { id: payload.platform };
    }
    // Company
    if (payload.hasOwnProperty('company') && isObject(payload.company) && payload.company.hasOwnProperty('id')) {
      this.company = { id: payload.company.id };
    } else if (isInteger(payload.company)) {
      this.company = { id: payload.company };
    }
  }
}

/**
 * Get widgets
 *
 */
export function getConfigs() {
  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*', 'platform.*', 'tags.*.*', 'company.*'],
      sort: '-created_on',
      status: 'published'
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Get widgets by company
 */
export function getConfigsByCompany(companyId) {
  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*', 'platform.*', 'tags.*.*', 'company.*'],
      sort: '-created_on',
      status: 'published',
      filter: {
        company: {
          eq: companyId
        }
      }
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Get widget by id
 *
 * @param {int} id
 */
export function getConfig(id) {
  if (!id) {
    throw new Error('Missing id');
  }

  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*', 'platform.*', 'tags.*.*', 'company.*'],
      status: 'published',
      filter: {
        id: {
          eq: id
        }
      }
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Save config
 */
export function saveConfig(payload) {
  const config = new SocialMediaConfig(payload);

  try {
    const response = client.createItem(COLLECTION, config);
    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Update config
 */
export function updateConfig(id, payload) {
  const config = new SocialMediaConfig(payload);
  console.log(config, id, payload);
  return client.updateItem(COLLECTION, id, config);

  // try {
  //   const response = client.updateItem(COLLECTION, id, widget);
  //   return response;
  // } catch (error) {
  //   throw new Error(error);
  // }
}
